import { 
	createSlice, 
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'
import {envAwarePost} from '../util/util'

export const getAllTags = createAsyncThunk(
	'accountTags/getAllTags',
	async () => envAwarePost('api/users/api/',{action:'getAllTags'})
)

export const deleteTag = createAsyncThunk(
	'accountTags/deleteTag',
	async tag_id => envAwarePost('api/users/api/',{
		action:'deleteTag',
		tag_id
	})
)

export const updateTagColor = createAsyncThunk(
	'accountTags/updateTagColor',
	async payload => {
		//trim # from tag color
		payload.color = payload.color.slice(1)
		return envAwarePost('api/users/api/',{
			action:'updateTagColor',
			...payload
		})
	}
)

export const updateTagName = createAsyncThunk(
	'accountTags/updateTagName',
	async payload => envAwarePost('api/users/api/',{
		action:'updateTagName',
		...payload
	})
)

export const createTag = createAsyncThunk(
	'accountTags/createTag',
	async payload => envAwarePost('api/users/api/',{
		action:'createTag',
		...payload})
)

const tagsAdapter = createEntityAdapter()

const accountTagsSlice = createSlice({
	name: 'accountTags',
	initialState:{
		status:'empty',
		adapter:tagsAdapter.getInitialState()
	},
	reducers: {
		insertTag:(state,action)=>{
			//add hex prefix to color
			action.payload.color = `#${action.payload.color}`
			tagsAdapter.upsertOne(state.adapter,action.payload)
        },
        addTagToClient: (state, action) => {
            console.log(action.payload)
			const {clientId,tag} = action.payload
			state.accountTags.adapter.entities[clientId].tags.push(tag)
		}
	},
	extraReducers:{
		[deleteTag.pending] : (state,action)=>{
			const tag_id = action.meta.arg
			tagsAdapter.removeOne(state.adapter,tag_id)
		},
		[updateTagColor.pending] : (state,action)=>{
			const {tag_id,color} = action.meta.arg
			tagsAdapter.updateOne(state.adapter,{
				id:tag_id,
				changes:{color}
			})
		},
		[updateTagName.pending] : (state,action)=>{
			const {tag_id,name} = action.meta.arg
			tagsAdapter.updateOne(state.adapter,{
				id:tag_id,
				changes:{name}
			})
		},
        [getAllTags.fulfilled]: (state, action) => {
            console.log(state.adapter)
			const {success,data} = action.payload
			if(success === '1') tagsAdapter.upsertMany(
				state.adapter,
				data.map(tag=>{
					//add pre-fix to tag color
					tag.color = `#${tag.color}`
					return tag
				})
			)
		},
		[createTag.fulfilled] : (state,action)=>{
			const {success,data} = action.payload
			//add hex prefix to color
			data.color = `#${data.color}`
			if(success === '1') tagsAdapter.upsertOne(state.adapter,data)
		}
	}
})

export const {addTagToClient} = accountTagsSlice.actions

console.log(tagsAdapter)
export const {insertTag} = accountTagsSlice.actions

// Export the customized selectors for this adapter using `getSelectors`
export const {
	selectAll: selectAllTags,
	selectById: selectTagById,
	selectIds: selectTagsIds
} = tagsAdapter.getSelectors(state => state.accountTags.adapter)

export default accountTagsSlice.reducer